import { ButtonProtected } from '@components'

import { MouseEvent, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { Scope } from '../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../enums/trackingContext'
import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { useSandboxModeContext } from '../../../../contexts'
import { SandboxBlockedTooltip } from '../../../SandboxBlockedTooltip'

export const NewInvoice = () => {
  const { t } = useTranslation()
  const isSandboxMode = !!useSandboxModeContext()
  const { url: newInvoiceUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice)),
  )

  const handleClick = useCallback(
    (event: MouseEvent) => {
      if (isSandboxMode) {
        event.preventDefault()
      }
    },
    [isSandboxMode],
  )

  return (
    <SandboxBlockedTooltip>
      <ButtonProtected
        fullWidth
        icon="plus"
        onClick={handleClick}
        scopes={Scope.BankReconciliationWrite}
        to={isSandboxMode ? undefined : newInvoiceUrl}
        trackingContext={TrackingContext.BankTransactions}
        variant="tonal"
      >
        {t('bank_transactions.drawer.create_invoice')}
      </ButtonProtected>
    </SandboxBlockedTooltip>
  )
}
